module.exports = __webpack_public_path__ + "img/edit.91f7f0ff.png";